import logoPath from '../../static/CloudGateway-logo.png';


export const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Cloud Gateway',
    url: 'https://www.cloudgateway.co.uk/',
    logo: `https://www.cloudgateway.co.uk${logoPath}`,
    description:
      "Cloud Gateway offers network and security services for the public and private sectors, powered by the UK's first fully managed SASE platform.",
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+44 (0) 203 870 2444',
      contactType: 'customer service',
      areaServed: 'GB'
    },
    sameAs: 'https://www.linkedin.com/company/cloudgateway/',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'The Ministry, 79-81',
      addressLocality: 'Borough Road',
      addressRegion: 'London',
      postalCode: 'SE1 1DN',
      addressCountry: 'UK'
    }
  }
  
  export const cloudConnectSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Cloud Connectivity',
    name: 'Cloud Connect',
    url: 'https://www.cloudgateway.com/cloud-connectivity',
    description:
      'Cloud Connect securely connects you to any cloud service provider, including Amazon Web Services (AWS), Microsoft Azure, and Google Cloud Platform (GCP)',
    provider: {
      '@type': 'Organization',
      name: 'Cloud Gateway',
      url: 'https://www.cloudgateway.com',
      logo: `https://www.cloudgateway.co.uk${logoPath}`,
      description:
        "Cloud Gateway offers network and security services for the public and private sectors, powered by the UK's first fully managed SASE platform.",
      sameAs: ['https://www.linkedin.com/company/cloud-gateway'],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+44 (0) 203 870 2444',
        contactType: 'Customer Service',
        email: 'sales@cloudgateway.co.uk'
      }
    }
  }
  
  export const psnConnectSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'PSN Connectivity',
    name: 'PSN Connect',
    url: ' https://www.cloudgateway.co.uk/services/psn-connect/',
    description:
      'PSN Connect is a portfolio of managed services that helps you to achieve fast, easy connectivity to the Public Services Network (PSN) from a physical site, a cloud environment or your remote user base.',
    provider: {
      '@type': 'Organization',
      name: 'Cloud Gateway',
      url: 'https://www.cloudgateway.co.uk',
      logo: `https://www.cloudgateway.co.uk${logoPath}`,
      description:
        "Cloud Gateway offers network and security services for the public and private sectors, powered by the UK's first fully managed SASE platform.",
      sameAs: ['https://www.linkedin.com/company/cloud-gateway'],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+44 (0) 203 870 2444',
        contactType: 'Customer Service',
        email: 'sales@cloudgateway.co.uk'
      }
    }
  }
  
  export const managedWanSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Managed WAN',
    name: 'Managed WAN',
    url: 'https://www.cloudgateway.co.uk/services/managed-wan/',
    description:
      'Cloud Gateway can bring your ecosystem together with a range of managed WAN connectivity options. From leased lines, to ethernet and more!',
    provider: {
      '@type': 'Organization',
      name: 'Cloud Gateway',
      url: 'https://www.cloudgateway.co.uk',
      logo: `https://www.cloudgateway.co.uk${logoPath}`,
      description:
        "Cloud Gateway offers network and security services for the public and private sectors, powered by the UK's first fully managed SASE platform.",
      sameAs: ['https://www.linkedin.com/company/cloud-gateway'],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+44 (0) 203 870 2444',
        contactType: 'Customer Service',
        email: 'sales@cloudgateway.co.uk'
      }
    }
  }
  
  export const remoteAccessSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Remote Access',
    name: 'Remote Access Service',
    url: 'https://www.cloudgateway.co.uk/services/remote-access/',
    description:
      'Cloud Gateway can securely connect your remote users to any network endpoint on your estate. From cloud, to data centres, to third party networks!',
    provider: {
      '@type': 'Organization',
      name: 'Cloud Gateway',
      url: 'https://www.cloudgateway.co.uk',
      logo: `https://www.cloudgateway.co.uk${logoPath}`,
      description:
        "Cloud Gateway offers network and security services for the public and private sectors, powered by the UK's first fully managed SASE platform.",
      sameAs: ['https://www.linkedin.com/company/cloud-gateway'],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+44 (0) 203 870 2444',
        contactType: 'Customer Service',
        email: 'sales@cloudgateway.co.uk'
      }
    }
  }
  
  export const dataCentreConnectivitySchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Data Centre Connectivity',
    name: 'Data Centre Connectivity',
    url: 'https://www.cloudgateway.co.uk/services/data-centre-connectivity/',
    description:
      'Data Centre connectivity allows you to connect to our platform from your own data centre presence, or that of an existing MPLS network provider.',
    provider: {
      '@type': 'Organization',
      name: 'Cloud Gateway',
      url: 'https://www.cloudgateway.co.uk',
      logo: `https://www.cloudgateway.co.uk${logoPath}`,
      description:
        "Cloud Gateway offers network and security services for the public and private sectors, powered by the UK's first fully managed SASE platform.",
      sameAs: ['https://www.linkedin.com/company/cloud-gateway'],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+44 (0) 203 870 2444',
        contactType: 'Customer Service',
        email: 'sales@cloudgateway.co.uk'
      }
    }
  }
  
  export const healthConnectSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'HSCN Connectivity',
    name: 'Health Connect',
    url: 'https://www.cloudgateway.co.uk/services/health-connect/',
    description:
      'Health Connect is a portfolio of managed services that helps you to achieve fast, easy connectivity to the The Health and Social Care Network (HSCN) from a physical site, a cloud environment or your remote user base.',
    provider: {
      '@type': 'Organization',
      name: 'Cloud Gateway',
      url: 'https://www.cloudgateway.co.uk',
      logo: `https://www.cloudgateway.co.uk${logoPath}`,
      description:
        "Cloud Gateway offers network and security services for the public and private sectors, powered by the UK's first fully managed SASE platform.",
      sameAs: ['https://www.linkedin.com/company/cloud-gateway'],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+44 (0) 203 870 2444',
        contactType: 'Customer Service',
        email: 'sales@cloudgateway.co.uk'
      }
    }
  }
  
  export const fwaasSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Firewall-as-a-service',
    name: 'Firewall-as-a-service',
    url: 'https://www.cloudgateway.co.uk/services/fwaas/',
    description:
      'Next generation network security. Firewall-as-a-Service (FWaaS) provides configurable firewall Unified Threat Management (UTM) capabilities to manage and control the traffic passing through your network estate.',
    provider: {
      '@type': 'Organization',
      name: 'Cloud Gateway',
      url: 'https://www.cloudgateway.co.uk',
      logo: `https://www.cloudgateway.co.uk${logoPath}`,
      description:
        "Cloud Gateway offers network and security services for the public and private sectors, powered by the UK's first fully managed SASE platform.",
      sameAs: ['https://www.linkedin.com/company/cloud-gateway'],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+44 (0) 203 870 2444',
        contactType: 'Customer Service',
        email: 'sales@cloudgateway.co.uk'
      }
    }
  }
  
  export const swgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Secure web gateway',
    name: 'Secure Web Gateway (SWG) Solution',
    url: 'https://www.cloudgateway.co.uk/services/swg/',
    description:
      'Secure Web Gateway (SWG) is a cyber security solution designed to safeguard corporate data and uphold security protocols.SWG filters unsafe content from web traffic, mitigating cyber threats and preventing data breaches. SWG also blocks risky and/or unauthorised user behaviour.',
    provider: {
      '@type': 'Organization',
      name: 'Cloud Gateway',
      url: 'https://www.cloudgateway.co.uk',
      logo: `https://www.cloudgateway.co.uk${logoPath}`,
      description:
        "Cloud Gateway offers network and security services for the public and private sectors, powered by the UK's first fully managed SASE platform.",
      sameAs: ['https://www.linkedin.com/company/cloud-gateway'],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+44 (0) 203 870 2444',
        contactType: 'Customer Service',
        email: 'sales@cloudgateway.co.uk'
      }
    }
  }
  
  export const wafSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Web Application Firewall (WAF)',
    name: 'Web Application Firewall (WAF)',
    url: 'https://www.cloudgateway.co.uk/services/waf/',
    description:
      'Web Application Firewall (WAF) is a highly sophisticated, configurable firewall that protects your web applications from malicious attacks.',
    provider: {
      '@type': 'Organization',
      name: 'Cloud Gateway',
      url: 'https://www.cloudgateway.co.uk',
      logo: `https://www.cloudgateway.co.uk${logoPath}`,
      description:
        "Cloud Gateway offers network and security services for the public and private sectors, powered by the UK's first fully managed SASE platform.",
      sameAs: ['https://www.linkedin.com/company/cloud-gateway'],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+44 (0) 203 870 2444',
        contactType: 'Customer Service',
        email: 'sales@cloudgateway.co.uk'
      }
    }
  }

  export const vpnSCSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'VPN Site Connectivity',
    name: 'VPN Site Connectivity',
    url: 'https://www.cloudgateway.co.uk/services/vpn-site-connectivity/',
    description:
      'Connect your sites to chosen endpoints via the Cloud Gateway platform on a ‘bring your own network’ basis - using your existing internet circuits and hardware.',
    provider: {
      '@type': 'Organization',
      name: 'Cloud Gateway',
      url: 'https://www.cloudgateway.co.uk',
      logo: `https://www.cloudgateway.co.uk${logoPath}`,
      description:
        'Cloud Gateway offers network and security services for the public and private sectors, powered by the UK’s first fully managed SASE platform.',
      sameAs: ['https://www.linkedin.com/company/cloud-gateway'],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+44 (0) 203 870 2444',
        contactType: 'Customer Service',
        email: 'sales@cloudgateway.co.uk',
      },
    },
  }
  
  export const blogPostSchema = (title, description, author, datePublished, imageUrl, postUrl,keywords) => {
      if(title && description && author && datePublished && imageUrl && postUrl ) {
        return (
      {
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      headline: title,
      description: description,
      author: {
        '@type': 'Person',
        name: author,
        url: 'https://www.cloudgateway.co.uk/about-us/meet-the-team/'
      },
      datePublished: datePublished,
      image: imageUrl,
      url: postUrl,
      publisher: {
        '@type': 'Organization',
        name: 'Cloud Gateway',
        logo: {
          '@type': 'ImageObject',
          url: `https://www.cloudgateway.co.uk${logoPath}`
        }
      },
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': postUrl
      },
      keywords: keywords
      
    })}
  };
  
  